import {connect} from 'react-redux';
import Entities from './Divisions';
import {selectEntityUi} from '../../../redux/actions/divisions';

const mapStateToProps = state => {
  return {
    app_state: state.app_state,
    divisions: state.divisions
  };
};

const mapDispatchToProps = dispatch => {
  return {
    selectEntityUi: value => {
      dispatch(selectEntityUi(value));
    }
  };
};

const EntitiesContainer = connect(mapStateToProps, mapDispatchToProps)(Entities);

export default EntitiesContainer;
